import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Shared navigation for the AI Governance workspace (nested under Compliance).
// Every sub-page renders this so a user can move freely between the workspace
// surfaces instead of being bounced back to Overview. The active tab is derived
// from the current route, so no page has to track its own selected state.
const AIGOV_TABS = [
  { to: '/dashboard/ai-governance',               i18n: 'AIGovernance.overview',     label: 'Overview', exact: true },
  { to: '/dashboard/ai-governance/assets',        i18n: 'AIGovernance.assets',       label: 'AI Assets' },
  { to: '/dashboard/ai-governance/soa',           i18n: 'AIGovernance.soa',          label: 'Statement of Applicability' },
  { to: '/dashboard/ai-governance/risk-register', i18n: 'AIGovernance.riskRegister', label: 'Risk Register' },
  { to: '/dashboard/ai-governance/documents',     i18n: 'AIGovernance.documents',    label: 'AIMS Documents' },
  { to: '/dashboard/ai-governance/monitoring',    i18n: 'AIGovernance.monitoring',   label: 'Continuous Monitoring' },
];

export default function AiGovNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const isActive = (tab) =>
    tab.exact ? pathname === tab.to || pathname === `${tab.to}/` : pathname.startsWith(tab.to);

  return (
    <div className="aig-tabs">
      {AIGOV_TABS.map((tab) => (
        <button
          key={tab.to}
          type="button"
          className={`aig-tab ${isActive(tab) ? 'aig-tab-active' : ''}`}
          onClick={() => navigate(tab.to)}
        >
          {t(tab.i18n, tab.label)}
        </button>
      ))}
    </div>
  );
}
